<script>
  import { emitter } from '@/main.js';
  import ProductListTopLeftBadge from '@/components/ProductListTopLeftBadge.vue';
  import ProductListBottomPillBadge from '@/components/ProductListBottomPillBadge.vue';
  import ProductListTextUnderBadge from '@/components/ProductListTextUnderBadge.vue';
  export default {
    components: {
      ProductListTopLeftBadge,
      ProductListBottomPillBadge,
      ProductListTextUnderBadge
    },
    name: 'ProductBadgePDP',
    data() {
      return {
        tags: [],
        badgeType: '',
        price: 0,
        isOutfitPickerText: false,
        priceBlockIndex: null
      };
    },
    mounted() {
      const parentElement = this.$el.parentElement;
      this.badgeType = parentElement.getAttribute('data-badge-type');
      const initialPrice = parentElement.getAttribute('data-product-price');
      this.price = initialPrice ? parseFloat(initialPrice) : 0;

      const priceEl = parentElement.parentElement?.querySelector('.PDPPriceBlock');
      this.isOutfitPickerText = this.badgeType === 'ProductListTextUnderBadge' && priceEl?.dataset.isOutfitPicker === 'true';
      if (this.isOutfitPickerText) {
        this.priceBlockIndex = Number(priceEl.dataset.outfitPickerPriceBlockIndex);
      }

      this.onTagsUpdated = e => {
        if (!this.isOutfitPickerText) {
          this.tags = e.tags;
          return;
        }
        if (Number(e.blockIndex) !== this.priceBlockIndex) return;
        this.tags = e.tags || [];
      };
      this.onUpdateAddButton = e => {
        if (this.isOutfitPickerText) return;
        if (e.variantPrice) {
          this.price = parseFloat(e.variantPrice) || 0;
        }
      };
      this.onUpdatePriceBlock = e => {
        if (!this.isOutfitPickerText || !e.isOutfitPicker || Number(e.blockIndex) !== this.priceBlockIndex) return;
        if (e.variantPrice) {
          this.price = parseFloat(e.variantPrice) || 0;
        }
      };

      emitter.on('pdp-tags-updated', this.onTagsUpdated);
      emitter.on('updateAddButton', this.onUpdateAddButton);
      emitter.on('updatePriceBlock', this.onUpdatePriceBlock);
    },
    beforeUnmount() {
      if (this.onTagsUpdated) emitter.off('pdp-tags-updated', this.onTagsUpdated);
      if (this.onUpdateAddButton) emitter.off('updateAddButton', this.onUpdateAddButton);
      if (this.onUpdatePriceBlock) emitter.off('updatePriceBlock', this.onUpdatePriceBlock);
    }
  };
</script>

<template>
  <component :is="badgeType" :tags="tags" :price="price" v-if="badgeType != ''"></component>
</template>
